/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MediaBaseService } from '../media-base-service';
import { MediaApiConfiguration } from '../media-api-configuration';
import { MediaStrictHttpResponse } from '../media-strict-http-response';

import { dashboardClientListPublisherIdGet$Json } from '../fn/dashboard/dashboard-client-list-publisher-id-get-json';
import { DashboardClientListPublisherIdGet$Json$Params } from '../fn/dashboard/dashboard-client-list-publisher-id-get-json';
import { dashboardClientListPublisherIdGet$Plain } from '../fn/dashboard/dashboard-client-list-publisher-id-get-plain';
import { DashboardClientListPublisherIdGet$Plain$Params } from '../fn/dashboard/dashboard-client-list-publisher-id-get-plain';
import { dashboardDashboardDownloadPost$Json } from '../fn/dashboard/dashboard-dashboard-download-post-json';
import { DashboardDashboardDownloadPost$Json$Params } from '../fn/dashboard/dashboard-dashboard-download-post-json';
import { dashboardDashboardDownloadPost$Plain } from '../fn/dashboard/dashboard-dashboard-download-post-plain';
import { DashboardDashboardDownloadPost$Plain$Params } from '../fn/dashboard/dashboard-dashboard-download-post-plain';
import { dashboardDashboardSearchPost$Json } from '../fn/dashboard/dashboard-dashboard-search-post-json';
import { DashboardDashboardSearchPost$Json$Params } from '../fn/dashboard/dashboard-dashboard-search-post-json';
import { dashboardDashboardSearchPost$Plain } from '../fn/dashboard/dashboard-dashboard-search-post-plain';
import { DashboardDashboardSearchPost$Plain$Params } from '../fn/dashboard/dashboard-dashboard-search-post-plain';
import { DashboardDownloadReponse } from '../models/dashboard-download-reponse';
import { dashboardPublisherListGet$Json } from '../fn/dashboard/dashboard-publisher-list-get-json';
import { DashboardPublisherListGet$Json$Params } from '../fn/dashboard/dashboard-publisher-list-get-json';
import { dashboardPublisherListGet$Plain } from '../fn/dashboard/dashboard-publisher-list-get-plain';
import { DashboardPublisherListGet$Plain$Params } from '../fn/dashboard/dashboard-publisher-list-get-plain';
import { DashboardResponse } from '../models/dashboard-response';
import { KeyValueGuidModel } from '../models/key-value-guid-model';

@Injectable({ providedIn: 'root' })
export class MediaDashboardService extends MediaBaseService {
  constructor(config: MediaApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `dashboardDashboardSearchPost()` */
  static readonly DashboardDashboardSearchPostPath = '/Dashboard/DashboardSearch';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardDashboardSearchPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardDashboardSearchPost$Plain$Response(params?: DashboardDashboardSearchPost$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<DashboardResponse>> {
    return dashboardDashboardSearchPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardDashboardSearchPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardDashboardSearchPost$Plain(params?: DashboardDashboardSearchPost$Plain$Params, context?: HttpContext): Observable<DashboardResponse> {
    return this.dashboardDashboardSearchPost$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<DashboardResponse>): DashboardResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardDashboardSearchPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardDashboardSearchPost$Json$Response(params?: DashboardDashboardSearchPost$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<DashboardResponse>> {
    return dashboardDashboardSearchPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardDashboardSearchPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardDashboardSearchPost$Json(params?: DashboardDashboardSearchPost$Json$Params, context?: HttpContext): Observable<DashboardResponse> {
    return this.dashboardDashboardSearchPost$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<DashboardResponse>): DashboardResponse => r.body)
    );
  }

  /** Path part for operation `dashboardDashboardDownloadPost()` */
  static readonly DashboardDashboardDownloadPostPath = '/Dashboard/DashboardDownload';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardDashboardDownloadPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardDashboardDownloadPost$Plain$Response(params?: DashboardDashboardDownloadPost$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<DashboardDownloadReponse>> {
    return dashboardDashboardDownloadPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardDashboardDownloadPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardDashboardDownloadPost$Plain(params?: DashboardDashboardDownloadPost$Plain$Params, context?: HttpContext): Observable<DashboardDownloadReponse> {
    return this.dashboardDashboardDownloadPost$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<DashboardDownloadReponse>): DashboardDownloadReponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardDashboardDownloadPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardDashboardDownloadPost$Json$Response(params?: DashboardDashboardDownloadPost$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<DashboardDownloadReponse>> {
    return dashboardDashboardDownloadPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardDashboardDownloadPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardDashboardDownloadPost$Json(params?: DashboardDashboardDownloadPost$Json$Params, context?: HttpContext): Observable<DashboardDownloadReponse> {
    return this.dashboardDashboardDownloadPost$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<DashboardDownloadReponse>): DashboardDownloadReponse => r.body)
    );
  }

  /** Path part for operation `dashboardClientListPublisherIdGet()` */
  static readonly DashboardClientListPublisherIdGetPath = '/Dashboard/ClientList/{publisherId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardClientListPublisherIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardClientListPublisherIdGet$Plain$Response(params: DashboardClientListPublisherIdGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueGuidModel>>> {
    return dashboardClientListPublisherIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardClientListPublisherIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardClientListPublisherIdGet$Plain(params: DashboardClientListPublisherIdGet$Plain$Params, context?: HttpContext): Observable<Array<KeyValueGuidModel>> {
    return this.dashboardClientListPublisherIdGet$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<KeyValueGuidModel>>): Array<KeyValueGuidModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardClientListPublisherIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardClientListPublisherIdGet$Json$Response(params: DashboardClientListPublisherIdGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueGuidModel>>> {
    return dashboardClientListPublisherIdGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardClientListPublisherIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardClientListPublisherIdGet$Json(params: DashboardClientListPublisherIdGet$Json$Params, context?: HttpContext): Observable<Array<KeyValueGuidModel>> {
    return this.dashboardClientListPublisherIdGet$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<KeyValueGuidModel>>): Array<KeyValueGuidModel> => r.body)
    );
  }

  /** Path part for operation `dashboardPublisherListGet()` */
  static readonly DashboardPublisherListGetPath = '/Dashboard/PublisherList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardPublisherListGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardPublisherListGet$Plain$Response(params?: DashboardPublisherListGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueGuidModel>>> {
    return dashboardPublisherListGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardPublisherListGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardPublisherListGet$Plain(params?: DashboardPublisherListGet$Plain$Params, context?: HttpContext): Observable<Array<KeyValueGuidModel>> {
    return this.dashboardPublisherListGet$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<KeyValueGuidModel>>): Array<KeyValueGuidModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardPublisherListGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardPublisherListGet$Json$Response(params?: DashboardPublisherListGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueGuidModel>>> {
    return dashboardPublisherListGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardPublisherListGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardPublisherListGet$Json(params?: DashboardPublisherListGet$Json$Params, context?: HttpContext): Observable<Array<KeyValueGuidModel>> {
    return this.dashboardPublisherListGet$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<KeyValueGuidModel>>): Array<KeyValueGuidModel> => r.body)
    );
  }

}
